export default __webpack_public_path__ + "2b3fa9b830c224370e0235d4dc54f19e.svg";